import styled from 'styled-components'

export const GridMainHeading = styled.div<{
    colorGuide: boolean
}>`
    display: flex;
    justify-content: space-between;
    padding: 20px;
    min-height: 150px;
    color: slategray;
    background-color: ${({ colorGuide }) => (colorGuide ? '#e3e4e6' : 'none')};
`
